import $ from 'jquery'
import {dependency} from '../utils/request'

// import printJS from 'print-js';
// import _ from 'lodash';

function initaliseIndex() {
	const CSRF = $('[name="CSRF_TOKEN"]')
	const form = $('#programsForm')
	const next = $('.continue #nextWithData')

	form.submit(function (e) {
		e.preventDefault()

		const _form = $(this)
		const formData = _form.serializeArray()
		const sub = $('.subscribe')
		const checked = sub.find('input[type=checkbox]:checked')

		$.post('', formData).done(function (data) {
			if (checked.length) {
				window.location.href = sub.data('url')
			} else {
				window.location.href = next.data('url')
			}
		})
	})

	next.click(function (e) {
		e.preventDefault()

		const _form = form
		const wrap = $('.question-wrap')

		wrap.removeClass('-invalid')

		if (_form[0].checkValidity()) {
			form.submit()
		} else {
			_form[0].reportValidity()
			wrap.addClass('-invalid')
		}
	})
}

function initialiseList() {
	const data = localStorage.getItem('completed');
	const length = $('[data-length]');
	const totalLength = length.attr('data-length');

	if (length.length === 0) {
		// Not a module list page
		return
	}

	const decoded = data ? JSON.parse(data) : []
	let completed = 0;

	decoded.forEach(function (el) {
		const programCard = $(`#${el}`)

		if (programCard.length) {
			programCard.addClass('-done')
			completed++
		}
	})

	const completedText = `Completed ${completed}/${totalLength}`

	if (completed > 0) {
		const heading = $('.heading')
		heading.addClass('-has-completed')
		heading.append(`<div class="heading-completed">${completedText}</div>`)
	}

	$('[data-completed-module-counter]').text(completedText)

	if (document.body.classList.contains('ff4f')) {
		length.find('a.card:not(.-done)').each((i, card) => {
			if (i > 0) {
				card.classList.add('-disabled')
			}
		})
	}
}

function initialiseProgramModules() {
	const btn = $('#completeModule')
	const id = parseInt($('[data-id]').data('id'))

	btn.on('click', function (e) {
		e.preventDefault()

		const data = localStorage.getItem('completed')
		let isInArr = false
		let decoded = []

		const href = btn.attr('href')

		if (data) {
			decoded = JSON.parse(data)

			decoded.forEach(function (el) {
				if (!isInArr && parseInt(el) === id) {
					isInArr = true
				}
			})

			if (!isInArr) {
				decoded.push(id)
			}
		} else {
			decoded.push(id)
		}

		localStorage.setItem('completed', JSON.stringify(decoded))

		if (localStorage.getItem('quiz')) {
			localStorage.removeItem('quiz')
		}

		window.location.href = href
	})
}

function initialisePrint() {
	const print = $('.print')
	if (print.length) {
		const printBtn = print.find('.button')

		dependency('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js')
		dependency('https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js', () => window.jsPDF && window.html2canvas).then(function () {
			printBtn.click(function (e) {
				e.preventDefault()

				const canvases = []

				const items = $('.pro_form-title, .pro_form_fields-item').toArray()
				const itemsLength = items.length

				const createPDF = function (cans) {
					const doc = new jsPDF('p', 'px', 'a4')

					let currentPageHeight = 25
					const maxPageHeight = doc.internal.pageSize.getHeight()
					const maxPageWidth = doc.internal.pageSize.getWidth() - 50

					cans.forEach(function (canvas) {
						const width = maxPageWidth
						const percent = canvas.height / canvas.width
						const heightMM = width * percent

						if ((currentPageHeight + heightMM) > maxPageHeight) {
							doc.addPage()
							currentPageHeight = 25
						}

						const imgData = canvas.toDataURL('image/png')

						if (imgData !== 'data:,') {
							doc.addImage(imgData, 'PNG', 25, currentPageHeight, width, heightMM)
							currentPageHeight += (heightMM + 20)
						}
					})
					doc.autoPrint()
					window.open(doc.output('bloburl'), '_blank')
				}

				items.forEach(function (el) {
					html2canvas(el, {
						onrendered: function (canvas) {
							canvases.push(canvas)

							if (canvases.length === itemsLength) {
								createPDF(canvases)
							}
						}
					})
				})
			})
		})
	}
}

function initialiseQuiz() {
	const nextBtn = $('#nextQuestion')
	const answerBlocks = $('.answers_item')
	// let prevBtn = $('#previousQuestion');

	nextBtn.on('click', function (e) {
		e.preventDefault()

		const _this = $(this)
		const error = $('.answers-error')
		const value = $('input[name="answers"]:checked').val()
		const id = $('[data-quiz-id]').attr('data-quiz-id')

		error.addClass('is-closed')

		if (value) {
			const href = _this.attr('href')

			let quiz = {}

			if (localStorage.getItem('quiz')) {
				quiz = JSON.parse(localStorage.getItem('quiz'))
			}

			quiz[id] = value
			localStorage.setItem('quiz', JSON.stringify(quiz))
			window.location.href = href
		} else {
			error.removeClass('is-closed')
		}
	})

	answerBlocks.click(function (e) {
		const _this = $(this)
		const radio = _this.find('input[type="radio"]')

		radio[0].checked = true
		_this.addClass('-selected')
		answerBlocks.not(_this).removeClass('-selected')
	})

	// prevBtn.on('click', function (e) {
	// 	e.preventDefault();
	//
	// 	let _this = $(this);
	// 	let href = _this.attr('href');
	// 	let quiz = [];
	//
	// 	// if has quiz, pop the last pushed value since we're returning to the previous page.
	// 	if (localStorage.getItem('quiz')) {
	// 		quiz = JSON.parse(localStorage.getItem('quiz'));
	// 		quiz.pop();
	// 		localStorage.setItem('quiz', JSON.stringify(quiz));
	// 	}
	//
	// 	window.location.href = href;
	// });
}

function initialiseQuizEnd() {
	// if no quiz items then redirect to modules page
	let quiz = {}
	if (localStorage.getItem('quiz')) {
		quiz = JSON.parse(localStorage.getItem('quiz'))

		let total = 0
		Object.keys(quiz).forEach(function (item) {
			const current = quiz[item]
			total += parseInt(current)
		})

		$('.pro_content-title').html('<span>Your Score:</span> ' + total)

		showTextWithScore(total)
	} else {
		window.location.href = $('#completeModule').attr('href');
	}
}

function showTextWithScore(total) {
	const scoringItems = $('.scoring_item')
	let show = null

	scoringItems.each(function () {
		const _this = $(this)
		const min = parseInt(_this.attr('data-min'))
		const max = parseInt(_this.attr('data-max'))

		if ((total >= min) && (total <= max)) {
			show = _this
		}
	})

	if (show) {
		show.removeClass('-hidden')
	}
}

function questions() {
	// $('.question .question-select-text').on('click', function(){
	// 	let _this = $(this),
	// 		parent = _this.parent(),
	// 		select = parent.find('select');
	// 	// select.click();
	// 	let event = new MouseEvent('mousedown');
	// 	select[0].dispatchEvent(event);
	// });

	$('.question .question-input-text').on('click', function () {
		const _this = $(this)
		const parent = _this.parent()
		const select = parent.find('input')

		select.focus()
	})

	$('.question select').on('change', function () {
		const _this = $(this)
		const parent = _this.parent()
		const i = parent.find('i').clone(true)
		const text = parent.find('.question-select-text')

		if (_this.val() === '') {
			text.html('select one')
			text.removeClass('-selected')
		} else {
			text.html(_this.val())
			text.addClass('-selected')
		}
		text.append(i)
	})

	$('.question input').on('keyup', function () {
		const _this = $(this)
		const parent = _this.parent()
		const text = parent.find('.question-input-text')

		if (_this.val() === '') {
			text.html('e.g: myself, my partner, three children')
			text.removeClass('-selected')
		} else {
			text.html(_this.val())
			text.addClass('-selected')
		}
	})
}

function initialiseProfQs() {
	const $itemsContainer = $('.prof-items');

	if ($itemsContainer.length) {
		const url = $itemsContainer.attr('data-url'),
			id = $('.pro_header[data-id]').attr('data-id'),
			title = $itemsContainer.attr('data-title');

		const $items = $itemsContainer.find('.prof-item');
		const $error = $('.pro_content-error');
		const $continueButton = $('.complete-prof-quiz');

		$continueButton.click(function (e) {
			e.preventDefault();

			let errorClass = '.prof-item_question.-error';
			let $qErrors = $(errorClass);

			$qErrors.removeClass('-error');
			$error.addClass('+hidden');

			$items.each(function (index, el) {
				const $this = $(this);
				const $checked = $this.find(`[name="question${index}"]:checked`);
				const $question = $this.find('.prof-item_question');
				let hasError = false;

				if ($checked.length) {
					const $container = $checked.closest('.prof-item-answer');

					if ($container.attr('data-correct') === 'no') {
						hasError = true;
					}
				} else {
					hasError = true;
				}

				if (hasError) {
					$question.addClass('-error');
					$error.removeClass('+hidden');
				}
			});

			$qErrors = $(errorClass);

			if ($qErrors.length) {
				const $first = $($qErrors[0]);

				setTimeout(() => {
					$('html, body').animate({
						scrollTop: $first.offset().top - 100
					}, 1000);
				}, 1000)
			} else {
				const $csrf = $('[name="CSRF_TOKEN"]');

				$.post({
					url: url,
					data: {
						id: id,
						title: title,
						CSRF_TOKEN: $csrf.val()
					}
				}).done(function (data) {
					const decoded = JSON.parse(data);
					if (decoded.success) {
						window.location.href = $continueButton.attr('href');
					} else {
						alert('An error has occurred. Please try again in a moment.');
					}
				});
			}
		});
	} else {
		const btn = $('.pro .complete-prof-quiz');
		if (btn.length) {
			const url = btn.attr('data-url'),
				id = $('.pro_header[data-id]').attr('data-id'),
				$csrf = $('[name="CSRF_TOKEN"]');

			btn.click(function (e) {
				e.preventDefault();

				$.post({
					url: url,
					data: {
						id: id,
						title: '',
						CSRF_TOKEN: $csrf.val()
					}
				}).done(function (data) {
					const decoded = JSON.parse(data);
					if (decoded.success) {
						window.location.href = btn.attr('href');
					} else {
						alert('An error has occurred. Please try again in a moment.');
					}
				});
			});
		}
	}
}

export default function programsSection() {
	const $html = $('html')

	$(function () {
		if ($('.programs').length) {
			initaliseIndex()
		}

		if ($('.programs-list, .ff4f-programs-list').length) {
			initialiseList()
		}

		if ($('#completeModule').length) {
			initialiseProgramModules()
		}

		initialisePrint()

		if ($('#nextQuestion').length) {
			initialiseQuiz()
		}

		const quiz = $('.pro_content.-quiz')
		// on intro remove the quiz data
		if (quiz.length && !quiz.hasClass('-question')) {
			if (localStorage.getItem('quiz')) {
				localStorage.removeItem('quiz')
			}
		}

		if ($('.pro_content.-quizEnd').length) {
			initialiseQuizEnd()
		}

		if ($('.questions').length) {
			questions()
		}

		initialiseProfQs();
	})
}



// WEBPACK FOOTER //
// ./source/scripts/sections/programs.js